import React from "react";
import ReactDOM from "react-dom";
import "bootstrap/dist/css/bootstrap.css";
import "./index.css";
import App from "./components/general/App.js";

ReactDOM.render(<App />, document.getElementById("root"));
